// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiRiskUploadController from "./ai_risk_upload_controller"
application.register("ai-risk-upload", AiRiskUploadController)

import AiRiskPeriodController from "./ai_risk_period_controller"
application.register("ai-risk-period", AiRiskPeriodController)

import AiRiskDlpFiltersController from "./ai_risk_dlp_filters_controller"
application.register("ai-risk-dlp-filters", AiRiskDlpFiltersController)

import AutoFilterController from "./auto_filter_controller"
application.register("auto-filter", AutoFilterController)

import BiometricsLockLifecycleController from "./biometrics_lock_lifecycle_controller"
application.register("biometrics-lock-lifecycle", BiometricsLockLifecycleController)

import BridgeBiometricsLockPreferenceController from "./bridge_biometrics_lock_preference_controller"
application.register("bridge--biometrics-lock-preference", BridgeBiometricsLockPreferenceController)

import CommunicationController from "./communication_controller"
application.register("communication", CommunicationController)

import CompanyProfileController from "./company_profile_controller"
application.register("company-profile", CompanyProfileController)

import CountryStateController from "./country_state_controller"
application.register("country-state", CountryStateController)

import FormController from "./form_controller"
application.register("form", FormController)

import MakerSuggestionsController from "./maker_suggestions_controller"
application.register("maker-suggestions", MakerSuggestionsController)

import MeetingButtonController from "./meeting_button_controller"
application.register("meeting-button", MeetingButtonController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OneClickController from "./one_click_controller"
application.register("one-click", OneClickController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import PollFrameController from "./poll_frame_controller"
application.register("poll-frame", PollFrameController)

import RecommendationController from "./recommendation_controller"
application.register("recommendation", RecommendationController)

import ScoreToggleController from "./score_toggle_controller"
application.register("score-toggle", ScoreToggleController)

import RefreshOnRestoreController from "./refresh_on_restore_controller"
application.register("refresh-on-restore", RefreshOnRestoreController)

import StaticModalController from "./static_modal_controller"
application.register("static-modal", StaticModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
